<template>
    <div class="textfield-scope">
        <header>
            <i class="el-icon-arrow-left"  @click="backPre"></i>
            <span class="pageTitle">{{ ptitle }}</span>
            <span class="save" @click="save">保存</span>
        </header>
        <div class="content">
            <div class="blank"></div>
            <div class="minContent">
                <input type="text" :value="pvalue" :placeholder="pplaceholder" class="oneline-input">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "textFieldPage",
        props: {
            ptitle: {
                type: String,
                default: ''
            },
            pvalue: {
                type: String,
                default: ''
            },
            pplaceholder: {
                type: String,
                default: ''
            }
        },
        methods: {
            backPre () {
                this.$emit('closePage')
            },
            save () {
                this.$emit('saveValue', document.getElementsByTagName('input')[0].value)
                this.backPre()
            }
        }
    }
</script>

<style scoped>
.textfield-scope {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
header {
  height: 1.5rem;
  width: 100%;
  background-image: linear-gradient(-134deg, #299EAD 0%, #299EAD 100%);
  position: fixed;
  z-index: 1;
}
.blank {
  height: 1.5rem;
  width: 100%;
}
.pageTitle {
  font-size: 0.5rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 45%;
  transform: translateY(-50%);
}
.save {
  font-size: 0.42rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 88%;
  transform: translateY(-50%);
}
.el-icon-arrow-left {
  font-size: 0.7rem;
  color: white;
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
}
.content {
  position: absolute;
  flex: 1;
  background-color: rgba(241, 241, 241, 1);
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}
.minContent{
    width: 100%;
    height: auto;
    margin-top: 0.39rem;
    text-align: center;
}
.oneline-input {
    width: 100%;
    height: .88rem;
    padding: .1rem;
}
</style>


// WEBPACK FOOTER //
// src/components/elements/textFieldPage.vue